import { twMerge } from '@shared/themes';
import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';
import { SecondaryHeader } from '../SecondaryHeader/SecondaryHeader';
import { SecondaryHeaderClient } from './components/SecondaryHeaderClient/SecondaryHeaderClient';

type SecondaryHeaderContainerProps = Omit<ComponentProps<typeof SecondaryHeader>, 'title' | 'className'> & {
  title: string;
  namespace: string;
  className?: string;
  backFallbackUrl?: string;
  actions?: React.ReactNode;
};

function SecondaryHeaderContainer({ children, title, namespace, className, extraInfo, backFallbackUrl, actions, ...props }: SecondaryHeaderContainerProps) {
  const t = useTranslations(namespace);

  return (
    <SecondaryHeaderClient className={actions ? twMerge('py-4', className) : className}>
      <SecondaryHeader title={namespace ? t(title) : title} className="ll-container-full" extraInfo={extraInfo} backFallbackUrl={backFallbackUrl} actions={actions} {...props}>
        {children}
      </SecondaryHeader>
    </SecondaryHeaderClient>
  );
}

export { SecondaryHeaderClient, SecondaryHeaderContainer };
